import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateGradeScaleSet from "./routes/CreateGradeScaleSet";
export default store => ({
  path: ":subject_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [CreateGradeScaleSet(store)],
});
